import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRulesTriggersEditType, TriggerFunnelFormSubscribedEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { getFunnelStepUrl } from 'modules/funnels/funnel/utils/get-funnel-step-url';
import { getFunnelUrl } from 'modules/funnels/utils/get-funnel-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
import { TriggerFormItem } from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-form-item';
interface TriggerFunnelFormSubscribedlItemProps extends EditTriggerItemInterface<TriggerFunnelFormSubscribedEditInterface> {}
export const TriggerFunnelFormSubscribedlItem = t0 => {
  const $ = _c(17);
  const {
    trigger,
    idx,
    onDelete,
    setRules,
    errors,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = trigger as AutomationRulesTriggersEditType;
  let t2;
  if ($[0] !== idx || $[1] !== onDelete) {
    t2 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.funnelStep.funnel || $[9] !== trigger.funnelStep.id || $[10] !== trigger.funnelStep.name || $[11] !== trigger.id) {
    t3 = t4 => {
      const {
        renderTriggerLabel,
        data,
        onOpen
      } = t4;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.funnel.title"),
          additionalLabel: trigger.funnelStep.funnel.id ? <LinkWithoutPrefetch href={getFunnelUrl(trigger.funnelStep.funnel.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel")} value={trigger.funnelStep.funnel.id} data={data.funnelsFormSubscribeData} staticData={getDataFromObj(trigger.funnelStep.funnel)} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: prev.triggers.map((el, i) => {
              if (i === idx) {
                return {
                  ...el,
                  funnelStep: {
                    funnel: {
                      id: data_0
                    },
                    id: undefined
                  }
                };
              }
              return el;
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.funnel?.join("")} />{trigger.funnelStep.funnel.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed_funnel_step)} label={renderTriggerLabel({
          label: t("dashboard.funnel.funnel_step"),
          additionalLabel: trigger.funnelStep.funnel.id && trigger.funnelStep.id ? <LinkWithoutPrefetch href={getFunnelStepUrl(trigger.funnelStep.funnel.id, trigger.funnelStep.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel_step")} value={trigger.funnelStep.id} staticData={getDataFromObj({
          id: trigger.funnelStep.id,
          name: trigger.funnelStep.name
        })} data={data.funnelStepsFormSubscribeData} onChange={selectedId => {
          setRules(prev_0 => ({
            ...prev_0,
            triggers: prev_0.triggers.map((el_0, i_0) => {
              if (i_0 === idx) {
                if (el_0.type === AutomationRuleTriggersEnum.form_subscribed) {
                  return {
                    ...el_0,
                    funnelStep: {
                      ...el_0.funnelStep,
                      id: selectedId
                    }
                  };
                }
              }
              return el_0;
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.funnelStep?.join("")} />}</>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.funnelStep.funnel;
    $[9] = trigger.funnelStep.id;
    $[10] = trigger.funnelStep.name;
    $[11] = trigger.id;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <EditTriggerWrapper trigger={t1} onDelete={t2}>{t3}</EditTriggerWrapper>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};